import React from 'react'

const IconSearchbar = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        d='M13.3729 12.5618L15.8327 15.021L15.02 15.8337L12.5608 13.3739C11.6458 14.1074 10.5076 14.5064 9.33487 14.5047C6.48166 14.5047 4.16602 12.189 4.16602 9.33584C4.16602 6.48264 6.48166 4.16699 9.33487 4.16699C12.1881 4.16699 14.5037 6.48264 14.5037 9.33584C14.5054 10.5086 14.1064 11.6467 13.3729 12.5618ZM12.2208 12.1356C12.9497 11.3861 13.3567 10.3813 13.3551 9.33584C13.3551 7.11439 11.5557 5.31563 9.33487 5.31563C7.11341 5.31563 5.31465 7.11439 5.31465 9.33584C5.31465 11.5567 7.11341 13.3561 9.33487 13.3561C10.3804 13.3577 11.3851 12.9507 12.1347 12.2218L12.2208 12.1356Z'
        fill='#686867'
      />
    </svg>
  )
}

export default IconSearchbar
